<app-hero
	[title]="'hero.partner' | translate"
	subtitle=""
	imageDesktop="assets/hero/partner-hero-3840x400.jpg"
	imageMobile="assets/hero/partner-hero-768x180.jpg"
/>

@if (partner) {
	<div class="container partner-detail mt-4">
		<button
			(click)="goBack()"
			class="nav-btn left text-uppercase"
		>
			<mat-icon>chevron_left</mat-icon>{{ "vehicle.button.back" | translate }}
		</button>
		<br />
		<div class="partner-detail-header">
			<div class="partner-detail-logo">
				<img
					loading="lazy"
					[src]="utils.getImageUrl(partner.smallLogo)"
					[alt]="partner.auctionName"
				/>
				<div class="d-none d-lg-block partner-detail-contacts">
					<h4>{{ "privatePartner.contacts" | translate }}</h4>
					<br />
					<p>
						<b>{{ "privatePartner.telephone" | translate }}: </b>
						<a
							href="tel:{{ partner.commercialInfoPhone }}"
							class="ck-link"
							style="padding: 5px"
						>
							{{ partner.commercialInfoPhone }}
						</a>
					</p>
					<p>
						<b>{{ "privatePartner.email" | translate }}: </b>
						<a
							class="ck-link"
							style="padding: 5px"
							[href]="'mailto:' + partner.commercialInfoEmail"
						>
							{{ partner.commercialInfoEmail }}
						</a>
					</p>
					<p>
						<b>{{ "privatePartner.vatCode" | translate }}:</b>
						{{ partner.vatCode }}
					</p>
				</div>
			</div>

			<div class="partner-detail-info">
				<div class="partner-detail-rating">
					<h2>{{ partner.auctionName }}</h2>
					<div class="stars">
						@for (star of getStars(partner.auctioneerRating); track $index) {
							<img
								class="star"
								[src]="'assets/icons/star' + (star === 'full' ? '-solid' : star === 'half' ? '-half-filled' : '') + '.svg'"
								alt="star"
							/>
						}
					</div>
					<span class="votes"> ({{ partner.numFeedback || 0 }}) </span>
				</div>
				<p class="partner-detail-description">
					{{ partner.description }}
				</p>

				<div class="d-lg-none partner-detail-contacts">
					<h4>{{ "privatePartner.contacts" | translate }}</h4>
					<br />
					<p>
						<b>{{ "privatePartner.telephone" | translate }}: </b>
						<a
							href="tel:{{ partner.commercialInfoPhone }}"
							class="ck-link"
							style="padding: 5px"
						>
							{{ partner.commercialInfoPhone }}
						</a>
					</p>
					<p>
						<b>{{ "privatePartner.email" | translate }}: </b>
						<a
							class="ck-link"
							style="padding: 5px"
							[href]="'mailto:' + partner.commercialInfoEmail"
						>
							{{ partner.commercialInfoEmail }}
						</a>
					</p>
					<p>
						<b>{{ "privatePartner.vatCode" | translate }}:</b>
						{{ partner.vatCode }}
					</p>
				</div>
			</div>
		</div>
	</div>
} @else {
	<div class="container mt-4">
		<button
			(click)="goBack()"
			class="nav-btn left text-uppercase"
		>
			<mat-icon>chevron_left</mat-icon>{{ "vehicle.button.back" | translate }}
		</button>

		<div class="partners-grid">
			@for (partner of partners; track partner) {
				<a
					class="partner-item"
					(click)="selectedPartner(partner)"
				>
					<div class="partner-logo">
						<img
							loading="lazy"
							[src]="utils.getOpenImageUrl(partner.smallLogo)"
							[alt]="partner.auctionName"
						/>
					</div>
					<span class="partner-name">
						{{ partner.auctionName }}
					</span>
				</a>
			}
		</div>
	</div>
}